import { render } from "./NavigationComponent.vue?vue&type=template&id=4dc1e2a0&scoped=true"
import script from "./NavigationComponent.vue?vue&type=script&lang=js"
export * from "./NavigationComponent.vue?vue&type=script&lang=js"

import "./NavigationComponent.vue?vue&type=style&index=0&id=4dc1e2a0&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc1e2a0"]])

export default __exports__